module.exports = __webpack_public_path__ + "f7770632960a1c367ca46b4263e10255.MP3";